import { providersService } from '../services';

export const Product = async () => {
  const { data } = await providersService.getProduct();
  return data;
};
